import React from 'react'
import styled from '@emotion/styled'
import { pluralize } from '@mobi/utils/string/pluralize'
import { colors, font, spacing } from '@mobi/component-library/Foundations'
import { Icon } from '@mobi/component-library/Assets/Icon'
import type { BetLoopSharedBet } from '@core/Areas/BetLoop/types'

export const PuntersCopiedLabel: React.FC<
  { shouldUseYourText: boolean } & Pick<BetLoopSharedBet, 'copyCount'>
> = ({ copyCount, shouldUseYourText }) => (
  <WrapperStyled data-testid='shared-bet-card-punters-copied-label'>
    <Icon name='DuocolorUsers02' size='1.6rem' />
    <span>
      {copyCount} {pluralize(copyCount, 'Punter')}{' '}
      {shouldUseYourText ? 'copied your bet' : 'copied this bet'}
    </span>
  </WrapperStyled>
)

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: spacing.smx1,
  fontFamily: font.family.primary,
  fontSize: font.size.lg.fontSize,
  lineHeight: font.size.lg.lineHeight,
  fontWeight: font.weight.medium,
  color: colors.neutral[900],
})
